import { lowerCase } from 'lodash-es';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, Typography } from 'seagull';
import { ServiceTemplateUsedIn } from "../../models/service-template/model";
import styles from "./UpdateExistingServicesContent.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UpdateExistingServicesContent = _ref => {
  let {
    serviceUsedIn
  } = _ref;
  const {
    control
  } = useFormContext();
  const usedInTypeToLabel = {
    [ServiceTemplateUsedIn.Draft]: 'Apply the new description to all drafts using this template',
    [ServiceTemplateUsedIn.ProposalTemplate]: 'Apply the new description to all proposal templates using this template'
  };
  const explanationText = (() => {
    if (serviceUsedIn.length === Object.values(ServiceTemplateUsedIn).length) {
      return 'This template is already used in existing proposal drafts and proposal templates.';
    }
    if (serviceUsedIn.length === 1) {
      return "This template is already used in existing ".concat(lowerCase(serviceUsedIn[0]), "s.");
    }
    return 'This template is already used in existing proposal drafts and proposal templates.';
  })();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsxs(Typography, {
      "data-testid": "update-existing-services-explanation-text",
      children: [explanationText, /*#__PURE__*/_jsx("br", {}), "You can choose to update them with the new description."]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.checkboxes,
      children: [...serviceUsedIn].sort().map(usedIn => /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: usedIn,
        render: _ref2 => {
          let {
            field
          } = _ref2;
          return /*#__PURE__*/_jsx(Checkbox, {
            inline: true,
            "data-testid": "update-existing-services-".concat(usedIn, "-checkbox"),
            checked: field.value,
            onChange: e => {
              field.onChange(e.target.checked);
            },
            children: /*#__PURE__*/_jsx(Typography, {
              children: usedInTypeToLabel[usedIn]
            })
          });
        }
      }, usedIn))
    })]
  });
};
export default UpdateExistingServicesContent;